import client from "./client";

export const registerUser = (payload) => client.post("/users/register", payload);

export const loginUser = (payload) => client.post("/users/login", payload);

export const logoutUser = () => client.post("/users/logout");

// Resolves the current session from the httpOnly cookie. Used on app load
// since the frontend can no longer just check "is there a token in
// localStorage" — the cookie isn't readable by JS at all.
export const getCurrentSession = () => client.get("/users/me");

export const verifyEmail = (token) => client.post("/users/verify-email", { token });

export const resendVerificationEmail = () => client.post("/users/resend-verification");

export const forgotPassword = (email) => client.post("/users/forgot-password", { email });

export const resetPassword = (token, password, confirmPassword) =>
  client.post("/users/reset-password", { token, password, confirmPassword });
